// src/api/dashboardApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

// GET /api/dashboard/stats  (base URL in apiClient already includes /api)
export const fetchDashboardStats = async () => {
  const res = await apiClient.get("/dashboard/stats", getAuthHeader());
  // your controller returns an object with keys: lawyers, firms, active_lawyers, blogs, cases
  return res.data;
};

export const getDashboardStats = async (userId) => {
  const headers = getAuthHeader();
  const res = await apiClient.get("/dashboard/get-stats", {
    ...headers,
    params: { user_id: userId }, // 👈 pass user_id
  });
  return res.data;
};